import Vue from 'vue'
import store from 'store'
import cookie from 'js-cookie'
import { TOKEN_COOKIE_NAME, TOKEN_COOKIE_CONF } from 'const/common'

store.watch(
  state => (state.account.identity || { uuid: '' }).uuid,
  uuid => {
    if (uuid) {
      Vue.Storage.path = 'storage-' + uuid
    }
  },
  { immediate: true }
)

store.watch(
  (state, getters) => getters.token,
  (newToken, oldToken) => {
    if (newToken) {
      cookie.set(TOKEN_COOKIE_NAME, newToken, TOKEN_COOKIE_CONF)
      store.dispatch('getAccountStatus')
    } else if (oldToken) {
      cookie.remove(TOKEN_COOKIE_NAME, TOKEN_COOKIE_CONF)
    }
  },
  { immediate: true }
)

store.watch(
  (state, getters) => getters.curAccountId,
  curAccountId => {
    if (curAccountId) {
      store.dispatch('getUserInfo')
      store.dispatch('getUserAssets')
      store.dispatch('getUserHoldings')
      store.dispatch('getAccountProcess')
      store.dispatch('getTradePermission')
    }
  },
  { immediate: true }
)

store.watch(
  (state, getters) => getters.language,
  () => {
    store.dispatch('getVirtualAccounts')
  }
)
